import NewOrganizationPage from '@/modules/business/pages/organizations/NewOrganization.vue';
import OrganizationSettingsPage from '@/modules/business/pages/organizations/OrganizationSettings.vue';
import RolesEdit from '@/modules/business/pages/roles/Edit.vue';
import DashboardPage from '@/modules/business/pages/dashboard/Index.vue';
import DocumentsPage from '@/modules/business/pages/documents/Index.vue';
import DocumentsInboxPage from '@/modules/business/pages/documents/Inbox.vue';
import DocumentsSentPage from '@/modules/business/pages/documents/Sent.vue';
import DocumentsDraftPage from '@/modules/business/pages/documents/Draft.vue';
import DocumentsWaitingReview from '@/modules/business/pages/documents/WaitingReview.vue';
import DocumentsTemplatePage from '@/modules/business/pages/documents/Template.vue';
import DocumentsBulkSendPage from '@/modules/business/pages/documents/BulkSend.vue';
import DocumentsBulkSendDetailsPage from '@/modules/business/pages/documents/BulkSendDetails.vue';
import DocumentsInfoPage from '@/modules/business/pages/documents/Info.vue';
import Teams from '@/modules/business/pages/teams/Index.vue';
import TeamsEdit from '@/modules/business/pages/teams/Edit.vue';
import UsersPage from '@/modules/business/pages/users/Index.vue';
import StoragePage from '@/modules/business/pages/storage/Storage.vue';
import EnvelopeSelectDocumentsPage from '@/modules/business/pages/envelopes/SelectDocuments.vue';
import EnvelopeRecipientsPage from '@/modules/business/pages/envelopes/Recipients.vue';
import EnvelopeFieldsPage from '@/modules/business/pages/envelopes/Fields.vue';
import EnvelopeReviewPage from '@/modules/business/pages/envelopes/Review.vue';
import EnvelopeViewerPage from '@/modules/business/pages/envelopes/Viewer.vue';
import EnvelopeDownloadPage from '@/modules/business/pages/envelopes/Download.vue';

import FaceToFaceSigningList from '@/modules/business/pages/envelopes/face-to-face-signing/List.vue';
import FaceToFaceSigningDocument from '@/modules/business/pages/envelopes/face-to-face-signing/Document.vue';
import BusinessLayout from '@/ui/layouts/Business.vue';

import store from './store/index';
import BulkSendSelectTemplate from '@/modules/business/pages/bulk-send/SelectTemplate.vue';
import BulkSendAddRecipients from '@/modules/business/pages/bulk-send/AddRecipients.vue';
import BulkSendReview from '@/modules/business/pages/bulk-send/Review.vue';
import ApiPermissions from '@/enums/ApiPermissions';

export default {
  name: 'business',
  routes: [
    {
      path: '/business/layout',
      component: BusinessLayout,
      redirect: {
        name: 'business',
      },
      children: [
        {
          path: '/business',
          name: 'business',
          redirect: '/business/dashboard',
        },
        {
          path: '/business/dashboard',
          name: 'business.dashboard',
          component: DashboardPage,
          meta: { permission: ApiPermissions.ENVELOPE_VIEW },
        },
        {
          path: '/business/organizations',
          name: 'business.organizations',
          redirect: '/business/organizations/new',
        },
        {
          path: '/business/organizations/settings',
          name: 'business.organizations.settings',
          component: OrganizationSettingsPage,
        },
        {
          path: '/business/organizations/new',
          name: 'business.organizations.new',
          component: NewOrganizationPage,
        },
        {
          path: '/business/roles/edit/:id',
          name: 'business.roles.edit',
          component: RolesEdit,
        },
        {
          path: '/business/documents/',
          name: 'business.documents',
          component: DocumentsPage,
          redirect: { name: 'business.documents.inbox' },
          children: [
            {
              path: 'inbox',
              name: 'business.documents.inbox',
              component: DocumentsInboxPage,
              meta: { permission: ApiPermissions.ENVELOPE_VIEW },
            },
            {
              path: 'sent/:state?',
              name: 'business.documents.sent',
              component: DocumentsSentPage,
              meta: {
                permission: ApiPermissions.ENVELOPE_VIEW,
              },
            },
            {
              path: 'draft',
              name: 'business.documents.draft',
              component: DocumentsDraftPage,
              meta: {
                permission: [
                  ApiPermissions.ENVELOPE_CREATE,
                  ApiPermissions.ENVELOPE_UPDATE,
                ],
              },
            },
            {
              path: 'waiting-review',
              name: 'business.documents.waiting-review',
              component: DocumentsWaitingReview,
              meta: {
                permission: [
                  ApiPermissions.ENVELOPE_VIEW,
                  ApiPermissions.ENVELOPE_REVIEW_UPDATE,
                ],
              },
            },
            {
              path: 'template',
              name: 'business.documents.template',
              component: DocumentsTemplatePage,
              meta: {
                permission: [
                  ApiPermissions.ENVELOPE_CREATE,
                  ApiPermissions.ENVELOPE_UPDATE,
                ],
              },
            },
            {
              path: 'bulk-send',
              name: 'business.documents.bulk-send',
              component: DocumentsBulkSendPage,
            },
          ],
        },
        {
          path: '/business/documents/:status',
          name: 'business.documents.status',
          component: DocumentsPage,
          meta: { permission: ApiPermissions.ENVELOPE_VIEW },
        },
        {
          path: '/business/documents/bulk-send/:uuid',
          name: 'business.documents.bulk-send-details',
          component: DocumentsBulkSendDetailsPage,
        },
        {
          path: '/business/documents/info/:id/:token?',
          name: 'business.documents.info',
          component: DocumentsInfoPage,
        },
        {
          path: '/business/checker/',
          name: 'business.checker',
          beforeEnter() {
            window.open('https://validar.iti.gov.br/.', '_blank');
          },
        },
        {
          path: '/business/users/',
          name: 'business.users',
          component: UsersPage,
        },
        {
          path: '/business/teams/',
          name: 'business.teams',
          component: Teams,
        },
        {
          path: '/business/teams/edit/:id',
          name: 'business.teams.edit',
          component: TeamsEdit,
        },
        {
          path: '/business/bulk-send/new',
          name: 'business.bulk-send.new',
          component: BulkSendSelectTemplate,
        },
        {
          path: '/business/bulk-send/:id/template',
          name: 'business.bulk-send.template',
          component: BulkSendSelectTemplate,
        },
        {
          path: '/business/bulk-send/:id/recipients',
          name: 'business.bulk-send.recipients',
          component: BulkSendAddRecipients,
        },
        {
          path: '/business/bulk-send/:id/review',
          name: 'business.bulk-send.review',
          component: BulkSendReview,
        },
        {
          path: '/business/envelopes/new',
          name: 'business.envelopes.new',
          component: EnvelopeSelectDocumentsPage,
          meta: { permission: ApiPermissions.ENVELOPE_CREATE },
        },
        {
          path: '/business/envelopes/:id/documents',
          name: 'business.envelope.documents',
          component: EnvelopeSelectDocumentsPage,
          meta: {
            permission: [
              ApiPermissions.ENVELOPE_CREATE,
              ApiPermissions.ENVELOPE_UPDATE,
              ApiPermissions.ENVELOPE_REVIEW_UPDATE,
            ],
          },
        },
        {
          path: '/business/envelopes/:id/recipients',
          name: 'business.envelope.recipients',
          component: EnvelopeRecipientsPage,
          meta: {
            permission: [
              ApiPermissions.ENVELOPE_CREATE,
              ApiPermissions.ENVELOPE_UPDATE,
              ApiPermissions.ENVELOPE_REVIEW_UPDATE,
            ],
          },
        },
        {
          path: '/business/envelopes/:id/fields',
          name: 'business.envelope.fields',
          component: EnvelopeFieldsPage,
          meta: {
            permission: [
              ApiPermissions.ENVELOPE_CREATE,
              ApiPermissions.ENVELOPE_UPDATE,
              ApiPermissions.ENVELOPE_REVIEW_UPDATE,
            ],
          },
        },
        {
          path: '/business/envelopes/:id/review',
          name: 'business.envelope.review',
          component: EnvelopeReviewPage,
          meta: {
            permission: [
              ApiPermissions.ENVELOPE_CREATE,
              ApiPermissions.ENVELOPE_UPDATE,
              ApiPermissions.ENVELOPE_REVIEW_UPDATE,
            ],
          },
        },
        {
          path: '/business/envelopes/viewer/:token',
          name: 'business.envelopes.viewer',
          component: EnvelopeViewerPage,
        },
        {
          path: '/business/envelopes/download/:token/:envelope?',
          name: 'business.envelopes.download',
          component: EnvelopeDownloadPage,
        },
        {
          path: '/business/envelopes/face-to-face',
          name: 'business.envelopes.faceToFaceList',
          component: FaceToFaceSigningList,
          meta: { permission: ApiPermissions.ENVELOPE_VIEW },
        },
        {
          path: '/business/envelopes/face-to-face/:token',
          name: 'business.envelopes.faceToFaceEnvelope',
          component: FaceToFaceSigningDocument,
        },
        {
          path: '/business/storage',
          name: 'business.storage',
          component: StoragePage,
          meta: {
            permission: ApiPermissions.STORAGE_VIEW,
          },
        },
        {
          path: '/business/storage/:itemId',
          name: 'business.storage.item',
          component: StoragePage,
          meta: {
            permission: ApiPermissions.STORAGE_VIEW,
          },
        },
      ],
    },
  ],
  store,
};
